module.exports = "\n<span>{{currentStr}}</span>\n";